module.exports = __webpack_public_path__ + "static/step3-c16c7b3fe09311129f16472f06e8c722.svg";